import { isValid, format, parseISO, toDate } from "date-fns";
import { nb } from "date-fns/locale";

import { assert } from "../assert";

export const parseDate = (date: string | number | Date, options: { utc?: boolean } = {}): Date => {
  let parsedDate;
  if (typeof date === "string") {
    parsedDate = parseISO(date);
  } else {
    parsedDate = toDate(date);
  }

  if (options.utc) {
    return new Date(Date.UTC(parsedDate.getFullYear(), parsedDate.getMonth(), parsedDate.getDate()));
  }
  return parsedDate;
};

export const isValidDate = (date: string | number | Date): boolean => {
  return isValid(parseDate(date));
};

export const formatDate = (date: string | number | Date, formatString: string): string => {
  assert(isValid(parseDate(date)), "Value must be a valid date");
  return format(parseDate(date), formatString, { locale: nb });
};

export const isPartialDate = (day: string, month: string, year: string): boolean => {
  return (!!day || !!month || !!year) && !(day && month && year && year.length === 4);
};
